import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Card, Button, Container, Badge } from 'react-bootstrap';
import PageWrapper from '../../components/PageWrapper';
import './Blogs.scss';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const Blogs1 = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/api/superadmin/blogs`);
      if (!res.ok) throw new Error('Failed to fetch blogs');
      const data = await res.json();
      setBlogs(data || []);
    } catch (err) {
      console.error('Error fetching blogs:', err);
    } finally {
      setLoading(false);
    }
  };
  console.log(blogs);

  const handleReadMore = (id) => {
    navigate(`/blogs2/${id}`);
  };

  return (
    <PageWrapper
      title="Blogs"
      subtitle="Read our latest blog posts and healthcare insights"
    >
      <section className="blogs-section py-5 px-3">
        <Container>
          <div className="section-header text-center mb-5">
            <h2>Blogs and News</h2>
            <div className="header-underline"></div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <p>Loading blogs...</p>
            </div>
          ) : blogs.length > 0 ? (
            <Row className="g-4">
              {blogs.map((blog) => (
                <Col key={blog.id} md={6} lg={4} className="mb-4">
                  <Card className="blog-card h-100">
                    {/* Blog Image */}
                    <div className="blog-image-wrapper">
                      {blog.title1_image ? (
                        <Card.Img
                          variant="top"
                          src={blog.title1_image}
                          alt={blog.title1}
                          className="blog-image"
                        />
                      ) : (
                        <div className="blog-image-placeholder">No Image</div>
                      )}
                    </div>

                    <Card.Body className="d-flex flex-column">
                      {/* CATEGORY */}
                      <div
                        className="align-self-start text-uppercase fw-semibold primary-class mb-1"
                        style={{ fontSize: '0.6rem' }}
                      >
                        {blog.category}
                      </div>

                      {/* TITLE */}
                      <Card.Title className="fw-bold mb-2">
                        {blog.title1}
                      </Card.Title>

                      {/* DESCRIPTION */}
                      <Card.Text className="blog-excerpt mb-3">
                        {blog.short_description}
                      </Card.Text>

                      {/* SEPARATOR LINE */}
                      <hr className="my-1"/>

                      {/* DATE + BUTTON (SAME LINE) */}
                      <div className="d-flex justify-content-between align-items-center " style={{ fontSize: '0.8rem' }}>
                        {/* DATE */}
                        {blog.published_date && (
                          <small className="text-muted">
                            {new Date(blog.published_date).toLocaleDateString()}
                          </small>
                        )}

                        {/* BUTTON */}
                        <Button
                          variant="outline-custom"
                          className="btn-read-more rounded-5"
                          onClick={() => handleReadMore(blog.id)}
                        >
                          Read More
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <div className="text-center py-5">
              <p>No blogs found.</p>
            </div>
          )}
        </Container>
      </section>
    </PageWrapper>
  );
};

export default Blogs1;
